import { VideoModalModule } from "../modals/video";
import { TimelineModule } from "../timeline/treatment";
import { AccordionSectionTextModule } from "../Accordions/section-text";
import { AccordionTextModule } from "../Accordions/accordion-text";
import { StickynavModule } from "../Stickynav/stickynav";
import { CarouselConsultantModule } from "../Carousels/consultants";
import { CarouselHomeModule } from "../Carousels/home";
import { GalleryModule } from "../Carousels/Gallery";
import { TreatmentareasAzModule } from "../TreatmentareaAz/treatmentareaAz";
import { LocationFinderModule } from "../finders/locationFinder";
import { CallToActionModule } from "../enquiryForms/callToAction";
import { EnquiryUrlCheckModule } from "../enquiryForms/enquiryUrlCheck";
import { RelatedContentModule } from "../content/relatedContent";
import { ConsultantFinderModule } from "../finders/consultantFinder";
import { HowCanWeHelpModule } from "../HospitalHome/HowCanWeHelp";
import { OnlinePaymentModule } from "../helpers/OnlinePaymentHelper";
import { FinanceCalculatorModule } from "../financeCalculator/financeCalculator";
import { FinanceEligibilityModule } from "../financeCalculator/financeEligibility";
import { CarouselRatingsModule } from "../Carousels/ratings";
import { RatingsSummaryModule } from "../ratings/ratings-summary";
import { RatingsListModule } from "../ratings/ratings-list";
import { Teamlistmodule } from "../teamlist/teamlist";
import { DropdownFindersModule } from "../finders/dropdownFinders";
import { ConsultantFilterModule } from "../filters/consultantFilter";
import { GlobalNotificationModule } from "../globalnotification/globalnotification";
import { ConsultantProfilemodule } from "../Consultants/Consultant";
import { TreatmentCarouselModule } from "../Carousels/TreatmentCarousel";
import { PatientFeedBackCarouselModule } from "../Carousels/PatientFeedbackCarousel";
import { HomeIntroductionPanelModule } from "../healthcareHome/healthcareHome";
import { CovidSurveyModule } from "../covidsurveyForms/covidsurvey";
import { TextReadMoreModule } from "../TextReadMore/TextReadMore";
import { ArticleLoadMoreModule } from "../Articles/articleLoadMore";
import { ScrollToBottomModule } from "../healthcareHome/ScrollToBottom";
import { BodyMapModule } from "../BodyMap/bodyMap";
import { ir35enquiryFormModule } from "../enquiryForms/ir35enquiryForm";
import { SplitContentPanelModule } from "../splitContentPanel/splitContentPanel";
import { ConsultantSearchFormModule } from "../consultantSearchForm/consultantSearchForm.js";
import { HospitalLocationsListModule } from "../Accordions/hospital-locations-list.js";
import { PricingModule } from "../Pricing/pricing";
import { MultiTopSlidingPanelModule } from "../Carousels/multiTopSlidingPanel";
import { CobpsCalendarModule } from "../cobpsCalendar/cobps-calendar";
import { FunnelBackModule } from "../funnelback/funnelback";
import { SearchOverlayModule } from "../SearchOverlay/search-overlay";
import { LocationApiLoader } from "../LocationApiLoader/location-api-loader";
import { PromoCarousel } from "../Carousels/PromoCarousel"
import { SimpleArticlesListModule } from "../Articles/simpleArticlesList";
import { TabbedCardListModule } from "../TabbedCardListPanel/tabbedCardList"
import { CobpsQuickBookModule } from "../cobpsQuickBook/cobpsQuickBook";

export class NestedLoader {
    constructor() {
        this.mapApiCallbacks = [];
        this.init();
    }
    
    loadLocationApiLoader() {
        const locationLookupModule = new LocationApiLoader(this.mapApiCallbacks); // NOSONAR
    }
    
    loadSearchOverlay() {
        const overlaySearchModule = new SearchOverlayModule(this.funnelBackModule, this.mapApiCallbacks); // NOSONAR
    }

    loadFunnelBack() {
        this.funnelBackModule = new FunnelBackModule(); // NOSONAR
    }

    loadTreatmentareas() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const galleryModule = new GalleryModule(); // NOSONAR
        const relatedContentModule = new RelatedContentModule(); // NOSONAR
        const carouselConsultant = new CarouselConsultantModule(); // NOSONAR
        const treatmentareaAzModal = new TreatmentareasAzModule(); // NOSONAR
        const consultantSearchFormModule = new ConsultantSearchFormModule(); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const homeCarouselModule = new CarouselHomeModule(); // NOSONAR
    }

    loadArticleLoadMore() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const articleLoadMoreModule = new ArticleLoadMoreModule(); // NOSONAR
        const treatmentareaAzModal = new TreatmentareasAzModule(); // NOSONAR
        const bodyMapModule = new BodyMapModule(); // NOSONAR
        const splitContentPanelModule = new SplitContentPanelModule(); // NOSONAR
        const tabbedCardListModule = new TabbedCardListModule();  // NOSONAR
    }

    loadTreatmentareasAz() {
        const treatmentareaAzModal = new TreatmentareasAzModule(); // NOSONAR
    }

    loadTreatments() {

        const videoModal = new VideoModalModule(); // NOSONAR
        const timelineModule = new TimelineModule(); // NOSONAR
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const carouselConsultant = new CarouselConsultantModule(); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
        const stickynavModule = new StickynavModule(); // NOSONAR
        const callToActionModule = new CallToActionModule(); // NOSONAR
        const relatedContentModule = new RelatedContentModule(); // NOSONAR
        const enquiryUrlCheckModule = new EnquiryUrlCheckModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
        const financeCalculatorModule = new FinanceCalculatorModule(); // NOSONAR
        const financeEligibilityModule = new FinanceEligibilityModule(); // NOSONAR
        const consultantSearchFormModule = new ConsultantSearchFormModule(); // NOSONAR
    }

    loadContentHubArticle() {        
        const videoModal = new VideoModalModule(); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const financeCalculatorModule = new FinanceCalculatorModule(); // NOSONAR
        const financeEligibilityModule = new FinanceEligibilityModule(); // NOSONAR
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
        const bodyMapModule = new BodyMapModule(); // NOSONAR
        const consultantSearchForm = new ConsultantSearchFormModule(); // NOSONAR
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
    }

    loadModuleContentPage() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const timelineModule = new TimelineModule();   // NOSONAR
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const homeCarouselModule = new CarouselHomeModule(); // NOSONAR
        const carouselConsultant = new CarouselConsultantModule(); // NOSONAR
        const treatmentCarouselModule = new TreatmentCarouselModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
        const homeIntroductionPanelModule = new HomeIntroductionPanelModule(); // NOSONAR
        const scrollToBottomModule = new ScrollToBottomModule(); // NOSONAR
        const ir35enquiryModule = new ir35enquiryFormModule(); // NOSONAR
        const consultantSearchFormModule = new ConsultantSearchFormModule(); // NOSONAR
        const promoCarousel = new PromoCarousel(); // NOSONAR
        const simpleArticlesList = new SimpleArticlesListModule(); // NOSONAR
        // if the following file gets added to a group module content page it potentially cause a crash.
        const patientFeedBackCarouselModule = new PatientFeedBackCarouselModule(); // NOSONAR
        const tabbedCardListModule = new TabbedCardListModule(); // NOSONAR
    }

    loadSymptoms() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const relatedContentModule = new RelatedContentModule(); // NOSONAR
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const enquiryUrlCheckModule = new EnquiryUrlCheckModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
    }

    loadConditions() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const relatedContentModule = new RelatedContentModule(); // NOSONAR
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const enquiryUrlCheckModule = new EnquiryUrlCheckModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
    }

    loadAcord() {
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
    }

    loadScans() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const relatedContentModule = new RelatedContentModule(); // NOSONAR
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const enquiryUrlCheckModule = new EnquiryUrlCheckModule(); // NOSONAR
        const carouselConsultant = new CarouselConsultantModule(); // NOSONAR
    }

    loadLocations() {
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
    }

    loadHospitalHome() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const carouselHomeModule = new CarouselHomeModule(); // NOSONAR
        const howCanWeHelpModule = new HowCanWeHelpModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
        const galleryModule = new GalleryModule(); // NOSONAR
        const textReadMoreModule = new TextReadMoreModule(); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const consultantSearchFormModule = new ConsultantSearchFormModule(); // NOSONAR
        const tabbedCardListModule = new TabbedCardListModule(); // NOSONAR
    }

    loadSimpleFacilityHome() {
        const carouselConsultant = new CarouselConsultantModule(); // NOSONAR
        const galleryModule = new GalleryModule(); // NOSONAR
        const carouselHomeModule = new CarouselHomeModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
    }

    loadPromoContent() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
        const consultantSearchFormModule = new ConsultantSearchFormModule(); // NOSONAR
        const splitContentPanelModule = new SplitContentPanelModule(); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const homeIntroductionPanelModule = new HomeIntroductionPanelModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
        const accordionSectionText = new AccordionSectionTextModule(); // NOSONAR
        const promoCarousel = new PromoCarousel(); // NOSONAR
        const tabbedCardListModule = new TabbedCardListModule(); // NOSONAR
    }

    loadHome() {
        const videoModal = new VideoModalModule(); // NOSONAR
        const carouselHomeModule = new CarouselHomeModule(); // NOSONAR
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const carouselRatingsModule = new CarouselRatingsModule(); // NOSONAR
        const globalNotification = new GlobalNotificationModule(); // NOSONAR
        const splitContentPanelModule = new SplitContentPanelModule(); // NOSONAR
        const consultantSearchFormModule = new ConsultantSearchFormModule(); // NOSONAR
        const tabbedCardListModule = new TabbedCardListModule(); // NOSONAR
    }

    loadOnlinePayments() {
        const onlinePaymentModule = new OnlinePaymentModule(); // NOSONAR
    }

    loadFinanceCalculator() {
        const financeCalculatorModule = new FinanceCalculatorModule(); // NOSONAR
    }

    loadFinanceEligibility() {
        const financeEligibilityModule = new FinanceEligibilityModule(); // NOSONAR
    }

    loadRatings() {
        const ratingsSummaryModule = new RatingsSummaryModule(); // NOSONAR
        const ratingsListModule = new RatingsListModule(); // NOSONAR
    }

    loadTeamlist() {
        const teamlistmodule = new Teamlistmodule(); // NOSONAR
        const relatedContentModule = new RelatedContentModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
    }

    loadConsultantsProfile() {
        const accordionText = new AccordionTextModule(); // NOSONAR
        const consultantModule = new ConsultantProfilemodule(); // NOSONAR
        const videoModal = new VideoModalModule(); // NOSONAR
        const cobpsCalendar = new CobpsCalendarModule(); // NOSONAR
        const cobpsQuickBook = new CobpsQuickBookModule(); // NOSONAR
    }

    loadConsultants() {
        const dropdownFindersModule = new DropdownFindersModule(); // NOSONAR
        const consultantFilterModule = new ConsultantFilterModule(); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
    }

    loadHomeCarousel() {
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
        const homeCarousel = new CarouselHomeModule(); // NOSONAR
        const carouselConsultant = new CarouselConsultantModule(); // NOSONAR
        const accordionText = new AccordionTextModule(); // NOSONAR
    }


    loadVideoModule() {
        const locationFinderModule = new LocationFinderModule(this.mapApiCallbacks); // NOSONAR
        const videoModal = new VideoModalModule(); // NOSONAR
        const consultantFinderModule = new ConsultantFinderModule(); // NOSONAR
        const treatmentCarouselModule = new TreatmentCarouselModule(); // NOSONAR
        const patientFeedBackCarouselModule = new PatientFeedBackCarouselModule(); // NOSONAR
        const covidModule = new CovidSurveyModule(); // NOSONAR
    }

    loadCovidModule() {
        const covidModule = new CovidSurveyModule(); // NOSONAR
    }

    loadPrices() {
        const hospitalLocationsListModule = new HospitalLocationsListModule(); // NOSONAR
        const accordionTextModule = new AccordionTextModule(); // NOSONAR
        const pricingModule = new PricingModule(); // NOSONAR
    }

    loadEnquiries() {
        const multiTopSlidingPanelModule = new MultiTopSlidingPanelModule(); // NOSONAR
    }

    init() {
        
        let bodyElement = document.getElementsByTagName('body')[0];
        let dataType = bodyElement.dataset.dtype;

        //console.log('DataType loaded is: ' + dataType)
        
        this.loadFunnelBack();
        this.loadSearchOverlay();

        /* Doc types needed */
        if (dataType === 'events') this.loadAcord();

        if (dataType === 'grouphome') this.loadHome();

        if (dataType === 'groupfolder' || dataType === 'hospitalfolder' || dataType === 'promomodulecontentpage') this.loadHomeCarousel();

        if (dataType === 'grouptreatmentprices' || dataType === 'hospitaltreatmentprices') this.loadPrices();

        if (dataType === 'GroupHome') this.loadHome();

        if (dataType === 'hospitalhome') this.loadHospitalHome();

        if (dataType === 'hospitaltreatment' || dataType === 'grouptreatment') this.loadTreatments();

        if (dataType === 'hospitalsymptom' || dataType === 'groupsymptom') this.loadSymptoms();

        if (dataType === 'hospitalscan' || dataType === 'groupscan') this.loadScans();

        if (dataType === 'hospitalcondition' || dataType === 'groupcondition') this.loadConditions();

        if (dataType === 'grouplocations' || dataType === 'grouptreatmentarea' || dataType === 'groupfolder') this.loadLocations();

        if (dataType === 'grouptreatmentarea' || dataType === 'hospitaltreatmentarea' || dataType === 'grouptreatmentareas' || dataType === 'hospitaltreatmentareas') this.loadTreatmentareas();

        if (dataType === 'grouptreatmentareasaz' || dataType == 'hospitaltreatmentareasaz') this.loadTreatmentareasAz();

        if (dataType === 'groupmodulecontentpage' || dataType == 'hospitalmodulecontentpage') this.loadModuleContentPage();

        if (dataType === 'onlinepaymentprocess') this.loadOnlinePayments();

        if (dataType === 'healthcarefinancecalculator') this.loadFinanceCalculator();

        if (dataType === 'healthcarefinanceeligibility') this.loadFinanceEligibility();

        if (dataType === 'groupratings') this.loadRatings();

        if (dataType === 'simplefacilityhome' || dataType == 'standaloneclinichome') this.loadSimpleFacilityHome();

        if (dataType === 'teamlist') this.loadTeamlist();
        if (dataType === 'consultant' || dataType === 'hospitalconsultant') this.loadConsultantsProfile();

        if (dataType === 'groupconsultantaz' || dataType === 'hospitalconsultantaz') this.loadConsultants();

        if (dataType === 'grouplocations' || dataType === 'groupfolder' || dataType === 'hospitalfolder' || dataType === 'promomodulecontentpage') this.loadVideoModule();

        if (dataType === 'promomodulecontentpage') this.loadPromoContent();

        if (dataType === "covidsurvey") this.loadCovidModule();
        
        if (dataType === "article") this.loadContentHubArticle();

        if (dataType === "contenthub" || dataType === "newtoprivatehealthcarehub" || dataType === "specialitycontent" || dataType === "specialityhub") this.loadArticleLoadMore();

        if (dataType === "groupenquiryform" || dataType === "ghospitalenquiryform") this.loadEnquiries();

        this.loadLocationApiLoader();
    }

}

